export function groupByMap<T, K extends string | number, R>(
  array: T[],
  keySelector: (item: T) => K,
  resultSelector: (groupKey: K, groupItems: T[]) => R,
): R[] {
  const groups = new Map<K, T[]>();

  for (const item of array) {
    const key = keySelector(item);
    const group = groups.get(key);
    if (group) {
      group.push(item);
    } else {
      groups.set(key, [item]);
    }
  }

  const result: R[] = [];
  for (const [key, items] of groups) {
    result.push(resultSelector(key, items));
  }

  return result;
}
